import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KeyboardForSearchBar from '../items/KeyboardForSearchBar';

const useStyles = makeStyles({
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
});

const useStyles1 = makeStyles({
  paper1: {
    fontFamily: 'Gilroy-SemiBold',
  },
  paper2: {
    visibility: 'hidden',
  },
});

function SearchBar(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { langs, themeColor } = props;
  const classes = useStyles();
  const class1 = useStyles1();

  let products = [];
  try {
    products = JSON.parse(localStorage.getItem('products'));
  } catch (e) {
    console.log('parse Product in Search Fail', e);
  }

  products = products ? products : [];
  let category = [];
  try {
    category = JSON.parse(localStorage.getItem('category'));
  } catch (e) {
    console.log('parse Category in Search Fail', e);
  }

  category = category ? category : [];

  category = category?.map((e) => {
    return { ...e, type: 'cate' };
  });

  let brand = [];
  try {
    brand = JSON.parse(localStorage.getItem('brand'));
  } catch (e) {
    console.log('parse Category in Brand Fail', e);
  }

  brand = brand ? brand : [];

  brand = brand?.map((e) => {
    return { ...e, type: 'brand' };
  });

  let result = [...products, ...category, ...brand];

  let machineID = JSON.parse(localStorage.getItem('machine'))?._id;
  const [show, setShow] = useState(false);
  const [input, setInput] = useState('');

  const goToProd = (v) => {
    let catename = v.name[langs] && v.name[langs] !== '' ? v.name[langs] : v.name?.en;
    if (v.type === 'brand') {
      localStorage.setItem('currentCate', JSON.stringify(v));
      history.push(`/machineUI/category/brand/${catename}/${v._id}`);
    } else if (v.type === 'cate') {
      localStorage.setItem('currentCate', JSON.stringify(v));
      history.push(`/machineUI/category/cate/${catename}/${v._id}`);
    } else {
      history.push(`/machineUI/product/${machineID}/${v._id}/${v.idx}`);
    }
  };

  const setShowhide = (v) => {
    setShow(false);
  };

  const setShowshow = (v) => {
    setShow(true);
  };

  return (
    <div
    // onClick={() => {
    //   keyboard.current.value = 'wewe';
    // }}
    >
      <Autocomplete
        className="searchBar"
        id="search-bar"
        options={result}
        classes={input === '' ? { paper: class1.paper2 } : { paper: class1.paper1 }}
        inputValue={input}
        onChange={(e, v) => goToProd(v)}
        getOptionLabel={(option) => {
          let name =
            option.name[langs] && option.name[langs] !== '' ? option.name[langs] : option.name?.en;

          if (option.type === 'brand') {
            name = name += ' (Brand)';
          } else if (option.type === 'cate') name = name += ' (Category)';
          return name;
        }}
        renderInput={(params) => (
          <TextField
            onClick={() => {
              console.log('themeColor?.theme', themeColor?.theme);
              setInput('');
            }}
            {...params}
            id="mydd"
            placeholder={t('Search the store')}
            InputProps={{ ...params.InputProps, classes }}
            onFocus={setShowshow}
            onBlur={setShowhide}
          />
        )}
      />
      {/* <div
        onClick={() => {
          console.log('click');

        }}
      >
        werwe
      </div> */}
      <KeyboardForSearchBar show={show} setShow={setShow} setInput={setInput} searchBar={true} />
    </div>
  );
}
export default SearchBar;
